import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ChevronRight } from "../../assets/icons/icon_chevron_right.svg"

interface IProps {
    breadcrumbs: Breadcrumb[]
}

interface Breadcrumb {
    name: string,
    url: string
}

const Breadcrumbs: React.FC<IProps> = ({ breadcrumbs }) => {
    return (
        <div className="breadcrumbs">
            {
                breadcrumbs.length > 1 &&
                breadcrumbs.map((breadcrumb, index) => {
                    return (
                        <Link
                            to={breadcrumb.url ?? ""}
                            key={index}
                            className="breadcrumb"
                        >
                            {breadcrumb.name} {index !== breadcrumbs.length - 1 && <ChevronRight />}
                        </Link>
                    )
                })
            }
        </div>
    )
}

export default Breadcrumbs;